<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <div class="content">
        <!-- HEAD Modify User -->
        <h1>{{$t('users.modifyUser')}}
            {{user['first-name']}} {{user.name}}
            ({{user.email}})</h1>
      </div>
      <hr>
      <form @submit.prevent="modifyUser()">
        <div class="content">
          <div class="column">
            <label>{{$t('addUser.email')}}</label>
            <input type="email" v-model="user.email">
            <p class="accentuate">{{$t('addUser.firstname')}}</p>
            <input type="text" v-model="user['first-name']">
            <p class="accentuate">{{$t('addUser.name')}}</p>
            <input type="text" v-model="user['name']">
            <p class="accentuate">{{$t('addUser.enterprise')}}</p>
            <input type="text" v-model="user['company']">
            <p class="accentuate">{{$t('addUser.phoneNumber')}}</p>
            <input type="tel" v-model="user['phone-number']">
            <br>
            <a>{{$t('modifyUser.resetPassword')}}</a>
          </div>
        </div>
        <hr>
        <div class="content">
          <p class="accentuate">{{$t('addUser.permissions')}}</p>
          <!--Récup des profiles-->
          <div class="row" v-for="data in profiles" :key="data.title">
            <div class="row" v-if="accesToProfileDependingOfCurrentUserRights(data)">
              <input type="radio" :value="data.id" name="userProfile" v-model="profile">
              <p>{{data.name}}</p>
              <p class="tips">{{data.description}}</p>
            </div>
          </div>
          <!--Profil perso-->
          <div class="row" v-if="$store.getters.USERPROFILE['user-profile-administration']">
            <input type="radio" value="perso" v-model="profile">
            <p>{{$t('addUser.personnalize')}}</p>
            <p class="tips">{{$t('addUser.persoLegend')}}</p>
          </div>
          <!--Récup des infos de profils personnalisé-->
          <div class="row" v-if="profile == 'perso'">
            <input type="text" class="smallInput mL" v-model="persoUserProfile['name']">
            <p class="tips">{{$t('addUser.personnalizeTips')}}</p>
          </div>
          <div class="row" v-if="profile == 'perso'">
            <input type="text" class="smallInput mL" v-model="persoUserProfile['description']">
            <p class="tips">{{$t('addUser.personnalizeDescriptionTips')}}</p>
          </div>
          <div class="row" v-if="profile == 'perso'">
            <input type="checkbox" v-model="persoUserProfile['default-profile']">
            <p>{{$t('newProfile.defaultProfile')}}</p>
          </div>
          <hr>
          <div class="row" v-if="profile == 'perso'">
            <div class="column">
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['user-administration']">
                <p>{{$t('newProfile.manageUsers')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['all-campaigns-access']">
                <p>{{$t('newProfile.accessAllCampaign')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['coupon-retrieval']">
                <p>{{$t('newProfile.assignCoupons')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['coupon-export']">
                <p>{{$t('newProfile.exportCoupons')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['campaign-follow-up']">
                <p>{{$t('newProfile.recapCampaign')}}</p>
              </div>
            </div>
            <div class="column">
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['campaign-administration']">
                <p>{{$t('newProfile.manageCampaign')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['sales-channel-administration']">
                <p>{{$t('newProfile.manageSalesChannels')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['product-administration']">
                <p>{{$t('newProfile.manageProducts')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['user-invitation']">
                <p>{{$t('newProfile.inviteUser')}}</p>
              </div>
              <div class="row">
                <input type="checkbox" v-model="persoUserProfile['user-profile-administration']">
                <p>{{$t('newProfile.manageProfiles')}}</p>
              </div>
            </div>
          </div>
        </div>
      </form>
      <hr>
      <div class="content">
        <div class="row">
          <button @click="modifyUserdependingProfile()">{{$t('button.validate')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Users from "@/services/Users";
import getProfiles from "@/mixins/getProfiles";
import Profiles from "@/services/Profiles";
export default {
  mixins: [getProfiles],
  props: ["parUserId"],
  data() {
    return {
      user: []
    };
  },
  mounted() {
    this.getUser();
    this.getProfiles();
  },
  methods: {
    getUser() {
      Users.getUserById(this.parUserId)
        .then(res => {
          this.user = res.data;
          this.profile = res.data["user-profile-id"];
        })
        .catch(err => console.log(err));
    },
    modifyUserdependingProfile() {
      if (this.profile == "perso") {
        Profiles.add(this.persoUserProfile).then(res => {
          if (res.status == 201) {
            var parts = res.headers["location"].split("/");
            this.profile = parts[parts.length - 1];
            this.modifyUser();
          }
        });
      } else this.modifyUser();
    },
    modifyUser() {
      this.user["user-profile-id"] = this.profile;
      var id = this.user.id;
      delete this.user.id;
      delete this.user["last-logging-date"];
      delete this.user["archived"];
      delete this.user["creation-date"];
      delete this.user["password"];
      Users.partialUpdate(id, this.user).then(res => {
        if (res.status == 204) {
          this.$emit('userchanged')
          this.$emit('close')
        }
      });
    }
  }
};
</script>